import { render } from "./MsInput.vue?vue&type=template&id=20197fb9&scoped=true"
import script from "./MsInput.vue?vue&type=script&lang=js"
export * from "./MsInput.vue?vue&type=script&lang=js"

import "./MsInput.vue?vue&type=style&index=0&id=20197fb9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20197fb9"]])

export default __exports__